import {Directive, HostListener, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserModel} from 'src/app/models/User';
import {DialogService} from 'primeng/dynamicdialog';
import {DashboardDealCardDto} from '../../models/DealsModels';
import {getBucketForId, MembershipBucket} from '../../models/SubscriptionsModels';
import {WaitlistModalComponent, WaitlistMode} from '../../components/modals/waitlist-modals/waitlist-modal.component';
import {TierUpgradeMode, UnlockDealModalComponent} from '../../components/modals/unlock-deal-modal/unlock-deal-modal.component';
import {UnlockedStarterDealsService} from '../../services/unlocked-starter-deals.service';
import { filter, take } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { openModal } from 'src/app/utilities/helpers';

@Directive({
    selector: '[dealActivate]',
})
export class DealActivateDirective implements OnInit{
    @Input('dealActivate') baseDeal!: DashboardDealCardDto;
    @Input() user!: UserModel;


    constructor(
        private router: Router,
        private dialogService: DialogService,
        private unlockedStarterDeals: UnlockedStarterDealsService,
        private auth: AuthService,
        private mixpanel: MixpanelService
    ) {}
    ngOnInit(): void {}

    @HostListener('click', ['$event'])
    onClick(ev: MouseEvent) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        const unlocked = this.unlockedStarterDeals.isUnlocked(this.baseDeal.id)
        const allowed = canViewDeal(this.user, this.baseDeal.minimumTier, this.baseDeal.currentUserGotDeal, unlocked);
        if (allowed) {
            const url = this.router.serializeUrl(
                this.router.createUrlTree(['/dashboard', 'deals', this.baseDeal.id])
            );
                this.mixpanel.identify(this.user.id.toString());
                if (this.baseDeal.destination.isDreamDestination) {
                    this.mixpanel.track('Dream destination deal clicked');
                }
                  this.mixpanel.track('View deal button clicked');

           return window.open(url, '_blank');
        }
        if (this.user.isOnWaitlist) {
           return this.dialogService.open(WaitlistModalComponent, {
                data: {
                    isVisible: true,
                    mode: WaitlistMode.upgrade,
                },
                width: '400px',
                breakpoints: {
                    '768px': '100%'
                },
                showHeader: false,
                styleClass: 'dashboard-modal',
                dismissableMask: true,
                appendTo: document.body,
                contentStyle: {
                    padding: '10px',
                    scrollbarWidth: 'none'
                }
            });
        }
        return openModal(this.dialogService, UnlockDealModalComponent, {data: {
                isVisible: true,
                mode: this.user.isFree ? TierUpgradeMode.freeToPremiumPlus : TierUpgradeMode.premiumToPremiumPlus
            },
        styleClass: 'dashboard-modal small-modal'})
    }

}


export function canViewDeal(user: UserModel, minimumTier: number, currentUserGotDeal: boolean, starterUnlocked?: boolean): boolean {
    if (user.isPremiumPlus) {
        return true;
    }

    const hasMembership = user.membershipId >= minimumTier;
    if (user.isPremium) {
        return hasMembership;
    }

    if (user.isFree) {
        if(!user.isOnWaitlist && starterUnlocked){
            return true;
        }
        return hasMembership && !!currentUserGotDeal && !user.isOnWaitlist;
    }

    return false;
}
